import { composeValidators, hasLengthGreaterThan, isRequired, isRequiredIf } from "revalidate";
import {
	atleastOneDigit,
	atleastOneSpecialChar,
	atleastOneUppercase,
	isCreditCardTypeAccepted,
	isCreditCardValid,
	isValidEmail,
	uniqueFullNameValidator,
} from "app/utils/form/validators.js";
import { determineCardType } from "app/utils/creditCardUtils";
import { CREDIT_CARDS_TYPES, PASSWORD_LIMIT_CHARS } from "app/constants";
import { isValidPhone } from "app/utils/form/validators";
import { namePolicyChar } from "./validators";

export const signInPasswordFieldValidator = composeValidators(
	isRequired({
		message: { id: "error.password.required" },
	})
)("password");

export const signUpPasswordFieldValidator = composeValidators(
	isRequired({
		message: { id: "error.password.required" },
	}),
	hasLengthGreaterThan(PASSWORD_LIMIT_CHARS)({
		message: { id: "auth.password.policy.atleast.ten.chars" },
	}),
	atleastOneUppercase({
		message: { id: "auth.password.policy.not.valid" },
	}),
	atleastOneDigit({
		message: { id: "auth.password.policy.not.valid" },
	}),
	atleastOneSpecialChar({
		message: { id: "auth.password.policy.not.valid" },
	})
)("password");

export const emailFieldValidator = composeValidators(
	isRequired({
		message: { id: "error.email.required" },
	}),
	isValidEmail({
		message: { id: "error.email.format" },
	})
)("email");

export const firstnameValidator = composeValidators(
	isRequired({
		message: { id: "error.firstName.required" },
	}),
	hasLengthGreaterThan(1)({
		message: { id: "error.firstName.minlength" },
	}),
	uniqueFullNameValidator({
		message: { id: "error.passengers.unique.invalid" },
	}),
	namePolicyChar({
		message: { id: "error.firstName.invalid" },
	})
)("firstname");

export const lastnameValidator = composeValidators(
	isRequired({
		message: { id: "error.lastName.required" },
	}),
	hasLengthGreaterThan(1)({
		message: { id: "error.lastName.minlength" },
	}),
	uniqueFullNameValidator({
		message: { id: "error.passengers.unique.invalid" },
	}),
	namePolicyChar({
		message: { id: "error.lastName.invalid" },
	})
)("lastname");

export const creditCardValidator = (creditCardTypes = []) =>
	composeValidators(
		isRequiredIf(({ number }) => {
			return determineCardType(number) !== CREDIT_CARDS_TYPES.MAESTRO;
		})({
			message: { id: "error.payment.card.number.required" },
		}),
		isCreditCardTypeAccepted(creditCardTypes)({
			message: { id: "error.payment.credit.card.type.not.accepted.new" },
		}),
		isCreditCardValid()({
			message: { id: "error.payment.credit.card.invalid" },
		})
	)("credit card");

export const phoneFieldValidator = composeValidators(
	isRequired({
		message: { id: "error.phone.required" },
	}),
	isValidPhone({
		message: { id: "error.phone.invalid" },
	})
)("phone");
